import {useParams} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {VerdocsAuth, VerdocsSend} from '@verdocs/web-sdk-react';
import {IProfile, TSession, VerdocsEndpoint} from '@verdocs/js-sdk';
import {postErrorToHost, postToHost, useHostResize} from './HostMessages';

export const Send: React.FC = () => {
  const {id = ''} = useParams();
  const [hasSession, setHasSession] = useState(false);
  const template = {template_id: id};
  useHostResize('send');

  useEffect(() => {
    const endpoint = VerdocsEndpoint.getDefault();

    const unsub = endpoint.onSessionChanged((_endpoint: VerdocsEndpoint, session: TSession, profile: IProfile | null) => {
      const originalPath = localStorage.getItem('originalPath');
      console.log('[SEND] Session changed', {session, profile, originalPath});

      if (session) {
        setHasSession(true);
      } else {
        setHasSession(false);
      }
    });

    endpoint.loadSession();

    return unsub;
  }, []);

  if (!hasSession) {
    return <VerdocsAuth />;
  }

  return (
    <VerdocsSend
      templateId={id}
      onSend={(e: any) => postToHost('send', 'sent', {...template, envelope_id: e.detail?.envelope_id})}
      onExit={() => postToHost('send', 'exit', template)}
      onSdkError={(e: any) => postErrorToHost('send', e, template)}
    />
  );
};
